import Client from '@/client'

export default {
  list() {
    return Client.get(`methods/`);
  },
  retrieve(id) {
    return Client.get(`methods/${id}/`)
  },
}